import React from 'react';
import './Menu.css';

const mocktails = [
  {
    name: "Passion Paradise Punch",
    description: "A tropical blend of passionfruit, ginger, and fresh citrus juices with a hint of vanilla."
  },
  {
    name: "Minty Mango Refresher",
    description: "Fresh mango puree mixed with aromatic mint leaves and sparkling water."
  },
  {
    name: "Berry Bliss",
    description: "A medley of mixed berries with lemon juice, simple syrup, and a touch of mint."
  },
  {
    name: "Cucumber Lime Cooler",
    description: "Crisp cucumber slices infused with fresh lime juice and herbal notes."
  }
];

const dirtySodas = [
  {
    name: "Cherry Cola Twist",
    description: "Premium cola mixed with fresh cherry syrup and a splash of vanilla cream."
  },
  {
    name: "Peach Cream Soda Dream",
    description: "Classic cream soda elevated with house-made peach syrup and whipped cream."
  },
  {
    name: "Strawberry Lemonade Soda",
    description: "Refreshing strawberry and lemon flavors mixed into sparkling soda water."
  },
  {
    name: "Orange Creamsicle",
    description: "A nostalgic combination of orange soda and creamy vanilla syrup."
  }
];

const boba = [
  {
    name: "Cookie Monster",
    description: "Creamy taro milk tea blended with coconut, topped with sea salt cold foam, crushed Oreos, and chewy brown sugar boba."
  },
  {
    name: "Brown Sugar Boba",
    description: "Rich and creamy with house-made brown sugar syrup and chewy boba."
  },
  {
    name: "Jasmine Green Tea",
    description: "Fragrant jasmine tea with floral notes and a smooth, refreshing taste."
  },
  {
    name: "Taro",
    description: "Velvety purple root tea with a nutty vanilla flavor and creamy texture."
  },
  {
    name: "Rose Chai",
    description: "Delicate rose-infused spiced chai tea with a hint of floral sweetness."
  },
  {
    name: "Passionfruit Tea",
    description: "Tropical and tangy, a vibrant favorite for tea lovers."
  },
  {
    name: "Mango Tea",
    description: "Sweet and juicy mango tea, perfect for sunny days and warm vibes."
  }
];

const toppings = [
  {
    name: "Tapioca",
    description: "Classic chewy black boba made fresh and soaked in brown sugar."
  },
  {
    name: "Passionfruit Popping Boba",
    description: "Juicy pearls that burst with tropical passionfruit flavor."
  },
  {
    name: "Mango Popping Boba",
    description: "Popping pearls filled with sweet mango juice."
  },
  {
    name: "Lychee Jelly",
    description: "Floral and chewy jelly made with real lychee extract."
  },
  {
    name: "Mango Jelly",
    description: "Smooth and sweet mango-flavored jelly with a soft texture."
  }
];

// const packages = [
//   {
//     title: "The Tea Time",
//     details: `Nothing serious... just premium beverages.
//         1.5 hours of service
//         2 drink selections
//         Floral cart decor included
//         UNLIMITED drinks`,
//     price: "$950"
//   },
//   {
//     title: "Habibis Special",
//     details: `Things are getting official — and so is your drink variety.
//         2 hours of service
//         3 different drink selections
//         Custom florals to match your theme
//         UNLIMITED drinks`,
//     price: "$1,150"
//   },
//   {
//     title: "The Premium Bundle",
//     details: `Unlimited drinks. Unlimited vibes. Unlimited love.
//         2.5 hours of service
//         Up to 4 drink selections (mix & match from all categories)
//         UNLIMITED drinks
//         Customized floral cart decor
//         Personalized cart vinyl sign
//         Custom cup stickers`,
//     price: "$1,500"
//   },
// ];

export default function Menu() {
  return (
    <div className="container py-5">
      <h2 className="text-center display-5 mb-4 fade-in" style={{ color: '#406b60' }}>Our Menu</h2>

      <h3 className="text-center mb-4 fade-in" style={{ color: '#406b60', animationDelay: '0.1s' }}>Mocktails</h3>
      <div className="row g-4 mb-5">
        {mocktails.map((item, index) => (
          <div className="col-md-6 fade-in" key={index} style={{ animationDelay: `${0.2 + index * 0.1}s` }}>
            <div className="menu-card p-4 shadow-sm rounded bg-white h-100">
              <h4 style={{ color: '#406b60' }}>{item.name}</h4>
              <p className="text-muted small">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h3 className="text-center mb-4 fade-in" style={{ color: '#406b60', animationDelay: '0.5s' }}>Dirty Sodas</h3>
      <div className="row g-4 mb-5">
        {dirtySodas.map((item, index) => (
          <div className="col-md-6 fade-in" key={index} style={{ animationDelay: `${0.6 + index * 0.1}s` }}>
            <div className="menu-card p-4 shadow-sm rounded bg-white h-100">
              <h4 style={{ color: '#406b60' }}>{item.name}</h4>
              <p className="text-muted small">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h3 className="text-center mb-4 fade-in" style={{ color: '#406b60', animationDelay: '0.9s' }}>Boba</h3>
      <div className="row g-4 mb-5">
        {boba.map((item, index) => (
          <div className="col-md-6 fade-in" key={index} style={{ animationDelay: `${1.0 + index * 0.1}s` }}>
            <div className="menu-card p-4 shadow-sm rounded bg-white h-100">
              <h4 style={{ color: '#406b60' }}>{item.name}</h4>
              <p className="text-muted small">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h3 className="text-center mb-4 fade-in" style={{ color: '#406b60', animationDelay: '1.3s' }}>Toppings</h3>
      <div className="row g-4 mb-5">
        {toppings.map((item, index) => (
          <div className="col-md-6 fade-in" key={index} style={{ animationDelay: `${1.4 + index * 0.1}s` }}>
            <div className="menu-card p-4 shadow-sm rounded bg-white h-100">
              <h4 style={{ color: '#406b60' }}>{item.name}</h4>
              <p className="text-muted small">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}
